<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <aside class="left_widgets p_filter_widgets">
    <div class="l_w_title">
      <a
        id="grid-icon2-btn"
        class="grid-icon2 d-lg-none"
        @click.prevent="$emit('toggleFilter', $event)"
      ><i
        class="icon-exit-left2"
        style="font-size: x-large;"
      /> Hide Filters</a>
    </div>

    <!-- Search via Postcode -->
    <div class="widgets_inner cat_widgets">
      <div class="border border-1 rounded p-1">
        <form
          class="ng-pristine ng-valid"
          @submit.prevent="$emit('getAddress', $event)"
        >
          <input
            id="bar_search"
            :value="postalCode"
            type="search"
            class="form-control"
            name="pql"
            minlength="3"
            :placeholder="userpostcode ? `Current: ${userpostcode}` : ''"
            @input="$emit('update:postalCode', $event.target.value)"
          >
          <label
            class="form-label"
            for="bar_search"
            style="margin-left: 0px; padding-top: 0.47rem"
          >Enter Your Postcode</label>
          <button
            type="submit"
            name="sendpostcode"
            class="lnrsubmit"
            style="line-height: 2; font-size: 20px; padding: 1px 12px"
          >
            <i class="icon-location" />
          </button>
        </form>
        <p v-if="loading">
          Loading...
        </p>
        <p v-if="address">
          Adress: {{ address }}
        </p>
        <p v-if="error">
          Error: {{ error }}
        </p>
      </div>
    </div>

    <!-- Pet Categories -->
    <div class="widgets_inner d-lg-none">
      <div class="mb-3 border border-1 rounded p-1">
        <label class="form-id">Pet Category:</label>
        <select
          :value="filters.category || 'All'"
          class="form-select mt-1"
          @change="$emit('updateFilters', { category: $event.target.value === 'All' ? null : $event.target.value, subCategory: null, coatPattern: null, color: null, ageGroup: null })"
        >
          <option value="All">
            All Categories
          </option>
          <option
            v-for="cat in categories"
            v-show="petCounts[`count_${cat.name}`] > 0"
            :key="cat.name"
            :value="cat.name"
          >
            {{ cat.name }} ({{ petCounts[`count_${cat.name}`] }})
          </option>
        </select>
      </div>
    </div>

    <!-- Dynamic Filters based on Category -->
    <div
      v-if="currentCategoryData"
      class="widgets_inner"
    >
      <!-- SubCategories / Breed -->
      <div
        v-if="currentCategoryData.subcategories && currentCategoryData.subcategories.length"
        class="mb-3 border border-1 rounded p-1"
      >
        <label class="form-id">Breed / Subcategory:</label>
        <select
          v-model="filters.subCategory"
          class="form-select"
          @change="$emit('updateFilters', {})"
        >
          <option :value="null">
            All Breeds
          </option>
          <template
            v-for="sub in currentCategoryData.subcategories"
            :key="sub"
          >
            <option 
              v-if="petCounts[`count_${currentCategoryData.name}_${sub}`] > 0"
              :value="sub"
            >
              {{ sub }} ({{ petCounts[`count_${currentCategoryData.name}_${sub}`] }})
            </option>
          </template>
        </select>
      </div>

      <!-- Coat Patterns -->
      <div
        v-if="currentCategoryData && currentCategoryData.coat_patterns && currentCategoryData.coat_patterns.length && ['Cats', 'Dogs'].includes(currentCategoryData.name)"
        class="mb-3 border border-1 rounded p-1"
      >
        <label class="form-id">Coat Pattern:</label>
        <select
          v-model="filters.coatPattern"
          class="form-select"
          @change="$emit('updateFilters', {})"
        >
          <option :value="null">
            All Patterns
          </option>
          <template
            v-for="pattern in currentCategoryData.coat_patterns"
            :key="pattern"
          >
            <option
              :value="pattern"
              :disabled="!(coatPatternCounts[pattern] > 0)"
            >
              {{ pattern }} ({{ coatPatternCounts[pattern] || 0 }})
            </option>
          </template>
        </select>
      </div>

      <!-- Colors -->
      <div
        v-if="currentCategoryData && currentCategoryData.colors && currentCategoryData.colors.length && ['Cats', 'Dogs'].includes(currentCategoryData.name)"
        class="mb-3 border border-1 rounded p-1"
      >
        <label class="form-id">Color:</label>
        <select
          v-model="filters.color"
          class="form-select"
          @change="$emit('updateFilters', {})"
        >
          <option :value="null">
            All Colors
          </option>
          <template
            v-for="col in currentCategoryData.colors"
            :key="col"
          >
            <option
              :value="col"
              :disabled="!(colorCounts[col] > 0)"
            >
              {{ col }} ({{ colorCounts[col] || 0 }})
            </option>
          </template>
        </select>
      </div>

      <!-- Age Group -->
      <div class="mb-3 border border-1 rounded p-1">
        <label class="form-id">Age Group:</label>
        <select
          v-model="filters.ageGroup"
          class="form-select"
          @change="$emit('updateFilters', {})"
        >
          <option :value="null">
            All Ages
          </option>
          <template
            v-for="group in ageGroups"
            :key="group"
          >
            <option
              v-if="ageGroupCounts[group] > 0"
              :value="group"
            >
              {{ group }} ({{ ageGroupCounts[group] }})
            </option>
          </template>
        </select>
      </div>

      <!-- Health Checks -->
      <div 
        v-if="currentCategoryData && ['Cats', 'Dogs'].includes(currentCategoryData.name)"
        class="mb-3 border border-1 rounded p-1"
      >
        <label class="form-id">Health & Vetting:</label>
        <div class="form-check mt-1">
          <input
            id="filterVaccinated"
            v-model="filters.isVaccinated"
            class="form-check-input"
            type="checkbox"
            :disabled="!(healthVettingCounts && healthVettingCounts.isVaccinated > 0)"
            @change="$emit('updateFilters', {})"
          >
          <label
            class="form-check-label"
            for="filterVaccinated"
          >Vaccinated ({{ (healthVettingCounts && healthVettingCounts.isVaccinated) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="filterMicrochipped"
            v-model="filters.isMicrochipped"
            class="form-check-input"
            type="checkbox"
            :disabled="!(healthVettingCounts && healthVettingCounts.isMicrochipped > 0)"
            @change="$emit('updateFilters', {})"
          >
          <label
            class="form-check-label"
            for="filterMicrochipped"
          >Microchipped ({{ (healthVettingCounts && healthVettingCounts.isMicrochipped) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="filterNeutered"
            v-model="filters.isNeutered"
            class="form-check-input"
            type="checkbox"
            :disabled="!(healthVettingCounts && healthVettingCounts.isNeutered > 0)"
            @change="$emit('updateFilters', {})"
          >
          <label
            class="form-check-label"
            for="filterNeutered"
          >Neutered / Spayed ({{ (healthVettingCounts && healthVettingCounts.isNeutered) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="filterHealthChecked"
            v-model="filters.isHealthChecked"
            class="form-check-input"
            type="checkbox"
            :disabled="!(healthVettingCounts && healthVettingCounts.isHealthChecked > 0)"
            @change="$emit('updateFilters', {})"
          >
          <label
            class="form-check-label"
            for="filterHealthChecked"
          >Health Checked ({{ (healthVettingCounts && healthVettingCounts.isHealthChecked) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="filterWormTreated"
            v-model="filters.isWormTreated"
            class="form-check-input"
            type="checkbox"
            :disabled="!(healthVettingCounts && healthVettingCounts.isWormTreated > 0)"
            @change="$emit('updateFilters', {})"
          >
          <label
            class="form-check-label"
            for="filterWormTreated"
          >Worm/Flea Treated ({{ (healthVettingCounts && healthVettingCounts.isWormTreated) || 0 }})</label>
        </div>
      </div>
    </div>

    <!-- Ad Types -->
    <div class="widgets_inner">
      <div class="mb-3 border border-1 rounded p-1">
        <label class="form-id">Ad Type:</label>
        <div class="form-check mt-1">
          <input
            id="adTypeSell"
            class="form-check-input"
            type="radio"
            name="adTypeFilter"
            :value="'For Sell'"
            :checked="selectedAdType === 'For Sell'"
            :disabled="!(adTypeCounts && adTypeCounts['For Sell'] > 0)"
            @click="$emit('updateAdType', 'For Sell')"
          >
          <label
            class="form-check-label"
            for="adTypeSell"
          >For Sell ({{ (adTypeCounts && adTypeCounts['For Sell']) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="adTypeReHoming"
            class="form-check-input"
            type="radio"
            name="adTypeFilter"
            :value="'Re-Homing'"
            :checked="selectedAdType === 'Re-Homing'"
            :disabled="!(adTypeCounts && adTypeCounts['Re-Homing'] > 0)"
            @click="$emit('updateAdType', 'Re-Homing')"
          >
          <label
            class="form-check-label"
            for="adTypeReHoming"
          >Re-Homing ({{ (adTypeCounts && adTypeCounts['Re-Homing']) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="adTypeStud"
            class="form-check-input"
            type="radio"
            name="adTypeFilter"
            :value="'For Stud'"
            :checked="selectedAdType === 'For Stud'"
            :disabled="!(adTypeCounts && adTypeCounts['For Stud'] > 0)"
            @click="$emit('updateAdType', 'For Stud')"
          >
          <label
            class="form-check-label"
            for="adTypeStud"
          >For Stud ({{ (adTypeCounts && adTypeCounts['For Stud']) || 0 }})</label>
        </div>
        <div class="form-check">
          <input
            id="adTypeBuy"
            class="form-check-input"
            type="radio"
            name="adTypeFilter"
            :value="'Want to Buy'"
            :checked="selectedAdType === 'Want to Buy'"
            :disabled="!(adTypeCounts && adTypeCounts['Want to Buy'] > 0)"
            @click="$emit('updateAdType', 'Want to Buy')"
          >
          <label
            class="form-check-label"
            for="adTypeBuy"
          >Want to Buy ({{ (adTypeCounts && adTypeCounts['Want to Buy']) || 0 }})</label>
        </div>
      </div>
    </div>
    <!-- Distance & Price Range (Commented Out) -->
    <div class="widgets_inner d-lg-none">
      <!-- <div class="mb-3 border border-1 rounded p-1">
            <label for="distance" class=" form-id"><i class="icon-arrow-wave"></i> Range Within...</label>
            <form id="distance-form" method="GET" class="ng-pristine ng-valid">
              <select class="form-select" name="farfromyou" id="id_distance" aria-label="Default select example" required="">
                <option value="" selected="">Nationwide</option>
                <option value="10">Within 10 miles</option>
                <option value="25">Within 25 miles</option>
                <option value="100">Within 100 miles</option>
              </select>
            </form>
          </div> -->
      <!-- PRICE RANGE COMMENTED OUT AS PER USER REQUEST 
      <label
        class="form-id"
        for="id_price__gt"
      >
        Price Range ( <i class="icon-cash-pound" /> ):
      </label>
      <input
        v-model="priceInputs.min"
        class="form-control"
        type="number"
        min="0"
        placeholder="Min. Price"
      >
      <input
        v-model="priceInputs.max"
        class="form-control"
        type="number"
        min="0"
        placeholder="Max. Price"
      >
      <div class="d-flex justify-content-between mt-2">
        <button
          class="grid-icon2"
          @click="$emit('applyPriceFilter')"
        >
          Apply
        </button>
        <button
          class="grid-icon2"
          style="background-color: #c5322d"
          @click="$emit('resetPriceFilter')"
        >
          Reset
        </button>

        <a
          id="parametre_holder"
          href="/pets/"
          type="submit"
          class="grid-icon2"
          style="
                  display: none;
                  box-shadow:
                    rgba(197, 50, 45, 0.4) 0px 2px 5px -3px,
                    rgba(197, 50, 45, 0.4) 0px 3px 5px 3px !important;
                "
        >Reset Filters
        </a>
      </div>
      -->

      <!-- Mobile Apply Filters Button -->
      <div class="mt-4 mb-4 pb-3 text-center">
        <button
          class="btn btn-primary w-100"
          style="padding: 10px 0; font-size: 1.1em; font-weight: bold; background-color: #0d6efd !important; color: #ffffff !important; border: none; border-radius: 5px;"
          @click.prevent="$emit('toggleFilter', $event)"
        >
          Apply Filters
        </button>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

defineProps({
  filters: Object,
  categories: Array,
  petCounts: Object,
  currentCategoryData: Object,
  coatPatternCounts: Object,
  colorCounts: Object,
  ageGroupCounts: Object,
  healthVettingCounts: Object,
  adTypeCounts: Object,
  ageGroups: Array,
  selectedAdType: String,
  activeFilterPanel: String,
  postalCode: String,
  userpostcode: String,
  loading: Boolean,
  address: String,
  error: String,
  priceInputs: Object
});

defineEmits([
  'toggleFilter',
  'getAddress',
  'updateFilters',
  'updateAdType',
  'applyPriceFilter',
  'resetPriceFilter',
  'update:postalCode',
  'update:activeFilterPanel'
]);
</script>
